import {createContext} from 'react'

const CatEstatusBajaInventarioContext = createContext()

export default CatEstatusBajaInventarioContext